import { render } from "./FilterDepartmentSidebar.vue?vue&type=template&id=59f682e6"
import script from "./FilterDepartmentSidebar.vue?vue&type=script&lang=js"
export * from "./FilterDepartmentSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__